import {
  ContainerFirstStripHeader,
  ContainerSecondStrip,
  ContainerTextFirstStrip,
  IconsHeader,
} from "./style";

import colorCraftPNG from "../../assets/images/header-icons/color-craft-logo.png";
import PadlockIconSVG from "../../assets/images/header-icons/padlock-icon.svg";

export default function Header({ display }) {
  return (
    <header>
      <ContainerFirstStripHeader>
        <ContainerTextFirstStrip>
          <img src={PadlockIconSVG} alt="padlock" />
          COMPRA 100% SEGURA
        </ContainerTextFirstStrip>
      </ContainerFirstStripHeader>
      <ContainerSecondStrip display={display}>
        <IconsHeader
          src={colorCraftPNG}
          mediaWidth="4.1vw"
          mediaHeight="5.7vw"
        ></IconsHeader>
        CHECKOUT COLOR CRAFT
      </ContainerSecondStrip>
    </header>
  );
}
